import React from "react";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  getOnePanelApplicationDetail,
  submitEnclosureFiles,
  submitPanelApproveRejectApplication,
} from "../auth/services/privateapicalling";
import MultiSelectCheckbox from "./PanelMultiSelectCheckbox";
import PdfLoaderModal from "../pages/pdfloader";

import { fieldsOptions } from "./PanelConstants";
import { docOptions } from "./PanelConstants";
import ApplicationTimelineModal from "../application/ApplicationTimeLineModal";
import SingleView from "../pages/pdfloader/Singleview";
import PanelApproveUnsigned from "./PanelApproveUnsigned";

import { getAllDistricts } from "../auth/services/apiCalling";
import EditPanelBorderDistrictModal from "./EditPanelBorderDistrictModal";
import GujaratiLetterDownload from "./DeclarationDGPDF";
import { isValid } from "date-fns";
import { ToastContainer,toast } from "react-toastify";
// import { isValid } from "date-fns";

interface ApplicationDetails {
  fileName: ApplicationDetails;
  docId: any;
  regClarificationToHoDetail: ApplicationDetails;
  applicantName: string;
  existFileClarification: string;
  partnershipFirm: string;
}
interface DocumentDetail {
  docId: string;
  documentName: string;
  fileName: string;
}
interface Document {
  docId: string;
  documentName: string;
  fileName: string;
}
interface ApplicationDetails {
  departmentId: string;
  applicantName: string;
  isPartner: string;
  panCardNo: string;
  yrOfExpAsBusErr?: number;
  regEmailId: string;
  mobileNo: string;
  representatives: any[];
  firmRepresentatives: any[];
  guarantorDetails: any[];
  applicationId: string;
  createdAt: string;
  docs: Document[];
  appStatusLevel: string;
  status: string;
  paymentStatus: string;
  itReturnDetail: DocumentDetail[];
  // regClarificationToHoDetail: Document;
  declarationDetail: DocumentDetail;
  departmentSelectType:string;
  borderDepartmentIdentifier: any;
  department: any;
  regclarificationToHoDetail: any;
  documentName: string;
  trackingNo:string;
  hasDrCheckedApplication:string;
  structuralDetail:any;
}

interface AddressData {
  address: string;
  post: string;
  taluka: string;
  district: string;
}

interface OfficeAddress {
  address: string;
  post: string;
  taluka: string;
  district: string;
}

interface OfficeDetails {
  DOB: string;
  registeredEmail: string;
  mobileNo: string;
}
interface Education {
  id: number;
  docId?: string;
  standard: string;
  specialization: string;
  documentName: string;
  fileName?: string;
}
interface Experience {
  id: number;
  projectName: string;
  projectAwardedby: string;

  eveidenceProof?: {
    docId: string;
    documentName: string;
    fileName: string;
  }; // Define structure properly
  startDate: string;
  endDate: string;
}
interface WorkPerformed {
  id: number;
  projectName: string;
  projectAwardedby: string;
  eveidenceProof?: {
    docId: string;
    documentName: string;
    fileName: string;
  }; // Optional attachment URL
  startDate: string;
  endDate: string;
}
interface ConstructionDetail {
  id: number;
  projectName: string;
  projectAwardedby: string;
  eveidenceProof?: {
    docId: string;
    documentName: string;
    fileName: string;
  }; // Optional attachment URL
  startDate: string;
  endDate: string;
}
interface Partner {
  id: number;
  name: string;
  partnerAge: number; // Updated property name
  address: string;
}

interface Enclosure {
  title: string;
  pdfUrl: string;
}

export interface Option {
  value: string;
  label: string;
}

const enclosures: Enclosure[] = [
  {
    title: " IT Return for Three Years",
    pdfUrl: "/path-to-return-for-three-years.pdf",
  },
  {
    title: "Applicant Declaration",
    pdfUrl: "/path-to-applicant-declaration.pdf",
  },
];

const PreviewPanelApplication: React.FC = () => {
  const [application, setApplication] = useState<ApplicationDetails | null>(
    null
  );
  const [comment, setComment] = useState<string>("");
  const [fieldComments, setFieldComments] = useState<{ [key: string]: string }>({});

  const [partners, setPartner] = useState<Partner[]>([]);
  const [addressData, setAddressData] = useState<AddressData | null>(null);
  // const [userAddress, setUserAddress] = useState<UserAddress | null>(null);
  const [officeAddress, setOfficeAddress] = useState<OfficeAddress | null>(
    null
  );
  const [officeDetails, setOfficeDetails] = useState<OfficeDetails | null>(
    null
  );
const[license, setLicense] = useState<boolean>(false);
  const roleIdentifier = useSelector(
    (state: any) => state.auth.userDetails?.Role?.Role_Identifier
  );

  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedDocId, setSelectedDocId] = useState<string | null>(null);
  const [education, setEducation] = useState<Education[]>([]);
  const [experience, setExperience] = useState<Experience[]>([]);
  const [workPerformed, setWorkPerformed] = useState<WorkPerformed[]>([]);
  const [existFileClarification, setExistFileClarifcation] = useState(
    application?.regClarificationToHoDetail?.fileName
      ? application?.regClarificationToHoDetail?.fileName
      : ""
  );
  const [constructionDetails, setConstructionDetails] = useState<
    ConstructionDetail[]
  >([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [decerror, setdecError] = useState<string | null>(null);
  const [errorr, setErrorr] = useState<{ [key: string]: string }>({});

  const [role, setRole] = useState<string>("");
  const [buttonData, setButtonData] = useState<any[]>([]);
  const [transaction, setTransaction] = useState<any[]>([]);
  const [docs, setDocs] = useState<any[]>([]);

  const language = useSelector((state: any) => state.auth.language);
  const [uploadedFiles, setUploadedFiles] = useState<Record<string, string>>(
    {}
  );
  const [rejectedDocName, setRejectedDocName] = useState<any[]>([]);
  const [rejectedFields, setRejectedFields] = useState<any[]>([]);
  
  const [districtOptions, setDistrictOptions] = useState<Option[]>([]);

  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [isChecked, setIsChecked] = useState<boolean>(false);

  const token = useSelector((state: any) => state.auth.token);
  //.log("rolee iddd redux", roleIdentifier);
  const location = useLocation();
  const applicationId = location.state?.applicationId;
  const [itArray, setItArray] = useState<string[]>([]);
      const [commentErrors, setCommentErrors] = useState<{ [key: string]: string }>({});
  

  const navigate = useNavigate();
  const educationLevelMap = {
    highSchool: 'High School ',
    diploma: 'Diploma ',
    bachelorDegree: 'Bachelor Degree ',
    mastersDegree: 'Masters Degree ',
    phd: 'Ph.D.',
  };
  const professionMap = {
    civilEngineer: ' Civil Engineer',
    architect: ' Architect',
    constructionEngineer: 'Construction Engineer',
    billingServiceEngineer: 'Billing Service Engineer',
  };
  // const [uploadedFiles, setUploadedFiles] = useState<Record<string, string>>({});

  const commentSchema = yup.object().shape({
     comment: yup.string()
         .required("Comment is required")
         .test(
           "min-words",
           "Comment must be at least 5 words",
           value => {
             if (!value) return false;
             return value.trim().split(/\s+/).length >= 5;
           }
         ),
      // .max(100, "comment cannot exceed 100 characters"),

      isChecked: yup
      .boolean()
      .oneOf([true], "Application approval is required")
  });

  const jcCoText = "ઉપર મુજબની તમામ વિગતોની અમોએ ચકાસણી કરેલ છે.(We have verified all the above-mentioned details.)"
  const drText = "જીલ્લા રજીસ્ટ્રારશ્રીનું પ્રમાણપત્ર ઉપર મુજબની તમામ વિગતોની અસલ પ્રમાણપત્રો સાથે અમોએ ચકાસણી કરેલ છે. જે આ અંગેના વડી કચેરીના પરીપત્રો સાથે સુસંગત છે. તેનું પ્રમાણપત્ર આપું છું. પેનલ ઈજનેર તરીકે નિમણૂક આપવા ભલામણ છે. ( We have verified all the above details with the original certificates. Which is in line with the circulars of the head office in this regard. I certify it. It is recommended to appoint a panel engineer.)"

  // const handleCommentChange = (field: string, value: string) => {
  //   const updated = { ...fieldComments, [field]: value };
  //   setFieldComments(updated);
  
  //   const combinedComment = Object.entries(updated)
  //     .map(([field, value]) => `${field}: ${value}`)
  //     .join(", ");
  //   setComment(combinedComment);
  // };

  const handleCommentChange = (field: string, value: string) => {
    const updated = { ...fieldComments, [field]: value };
    setFieldComments(updated);

    
  setCommentErrors((prevErrors) => {
    const newErrors = { ...prevErrors };
    delete newErrors[field];
    return newErrors;
  });
  
    const combinedComment = Object.entries(updated)
      .filter(([_, val]) => val.trim() !== "") // only include non-empty comments
      .map(([key, val]) => `${key}: ${val.trim()}`)
      .join(", ");
      
    setComment(combinedComment);
  };

  const handleFileUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setUploadedFile(file);
      setError("");
      const formData = new FormData();
      
      const existingDoc =
        application && application?.regClarificationToHoDetail;
   

      let docId = existingDoc?.docId ? existingDoc?.docId : "";
      
      formData.append("file", file as Blob);
      formData.append("documentName", "regClarificationToHo");
      formData.append("applicationId", applicationId);
      //.log("Uploaded File:", file.name);
      try {
        const res = await submitEnclosureFiles(formData, token, docId);
        //.log("Declaration ress:", res);
        if (res.success == true) {
          fetchApplicationDetails(applicationId);
        } else if (res.success == false) {
          toast.error(res.message);
        }
      } catch (error) {
        //.error("Error uploading declaration:", error);
        setError("Error uploading declaration. Please try again later.");
      }
    }
  };

  const handleSubmit = async (status: string, appStatusLevel: string) => {

    if (!status || (!appStatusLevel && !applicationId)) {
    toast.error("Status not found");
      return;
    }

    
    const formData = {
      comment: comment,
      status: status,
      appStatusLevel: appStatusLevel,
      applicationId: applicationId,
      reSubmittedDocs: [],
      reSubmittedFields: [],
      rejectedDocName: rejectedDocName || [],
      rejectedFieldName: rejectedFields || [],

    };
    
 

    setIsDisabled(true);
    try {

      // Validate formData using Yup
if(!license && application?.appStatusLevel == "hoSuperintendentAfterApproveAction" && roleIdentifier == "HOS")
 {toast.error("Please upload license document");
  return;
 }
      setErrorr({});
      let isvalid = true;
      if((roleIdentifier == "JC" || roleIdentifier=="COM" || roleIdentifier=="Dr" ) && (application.status == "pending" || application.status == "resubmission"  ) && (status !="reject"))
      {
        (formData as any).isChecked = isChecked;
      }
      
      const appStatusLevelTrimmed = application?.appStatusLevel?.trim();
const roleIdentifierTrimmed = roleIdentifier?.trim();
      if(
          (appStatusLevelTrimmed === "dclerkAfterRejectionAction" && roleIdentifierTrimmed === "JC") ||
          (appStatusLevelTrimmed === "hoSuperintendentAfterRejectionAction" && roleIdentifierTrimmed === "HOS")
        ) 
      {
      

        if(Object.keys(formData.rejectedFieldName).length==0)
        {
          
          isvalid=false 
          const err = {
            requery: 'Raise Query is required'
          }
          setErrorr(err)
         return;

        }
        else{
          isvalid=true
        }

        if(Object.keys(formData.rejectedFieldName).length>0)
        {
          const errors: { [key: string]: string } = {};
         
            rejectedFields.forEach((fieldKey) => {
              const comment = fieldComments[fieldKey];
              if (!comment || comment.trim() === "") {
                errors[fieldKey] = "Comment is required.";
              } else if (comment.trim().split(/\s+/).length < 5) {
                errors[fieldKey] = "Comment must be at least 5 words.";
              }
            });

            // If there are any missing comments
            if (Object.keys(errors).length > 0) {
              setCommentErrors(errors); // set all at once
              return null;
            }

            setCommentErrors({});
        }

      
      }
      const cc = await commentSchema.validate(formData ,  { abortEarly: false });
     
      
      if (isvalid) {
        const submitData = await submitPanelApproveRejectApplication(
          formData,
          token
        );
        //.log("Submitted Data Response:", submitData);

        if (submitData.success) {
          if (submitData.data.status === "reject") {
            toast.warn("Raised-Query successfully!");
          }
          else if(submitData.data.status === "permanentReject"){
            toast.warn("Application permanently rejected!");
          } else if(submitData.data.status === "approvedUnsigned"){
            toast.success("Application Approved!");
          } else {
            toast.success("Form submitted successfully!");
          }
          setButtonData([]);
          fetchApplicationDetails(applicationId);
          navigate("/panel-application");
        } else {
          toast.error("Submission failed, please try again.");
        }
      } else {
        if(application.status == "pending")
        setdecError("Declaration is required");
      }
    } catch (error) {
      if (error instanceof yup.ValidationError) {
        
        const errorObj: { [key: string]: string } = {};

        error.inner.forEach((err) => {
          if (err.path) {
            errorObj[err.path] = err.message;
        
          }
        });
       
        setErrorr(errorObj);
      } else {
        //.error("Error submitting form:", error);
        toast.error("An error occurred while submitting the form.");
      }
    } finally {
      setIsDisabled(false); 
    }
  };

  const handleSelectionChange = (values: string[]) => {
    //.log("valueeesss", values);
    setRejectedFields(values);
  };

  const handleDocsSelectionChange = (values: string[]) => {
    //.log("valueeesss", values);

    //.log("docs", docs);
    const filteredDocs = docs?.filter((doc) =>
      values.map((value) => value).includes(doc.docName)
    );

    //.log("Filtered values:", filteredDocs);

    setRejectedDocName(filteredDocs);
  };

  const fetchApplicationDetails = async (appId: any) => {
    try {
      //.log("fff");
      //.log("apppidddd", appId);
      const data = await getOnePanelApplicationDetail(appId, token);
      if (!data?.success) {
        navigate("/error-404");
      }
      setApplication(data.data);
     
      setPartner(
        data.data.partnerDetails.map((partner: any) => ({
          name: partner.partnerName || "N/A",
          partnerAge: partner.partnerAge || "N/A",
          address: partner.partnerAddress || "N/A",
        }))
      );

      setAddressData({
        address: data.data.perAddress.at || "N/A",
        post: data.data.perAddress.post || "N/A",
        taluka: data.data.perAddress.taluka || "N/A",
        district: data.data.perAddress.district || "N/A",
      });

      setOfficeAddress({
        address: data.data.regOffAddress.at || "N/A",
        post: data.data.regOffAddress.post || "N/A",
        taluka: data.data.regOffAddress.taluka || "N/A",
        district: data.data.regOffAddress.district || "N/A",
      });

      setOfficeDetails({
        DOB: data.data.dob || "N/A",
        registeredEmail: data.data.regEmailId || "N/A",
        mobileNo: data.data.mobileNo || "N/A",
      });

      setEducation(data.data.eduQualification || []);
      setExperience(data.data.experienceDetail || []);
      setWorkPerformed(data.data.govSemiGovExpDetail || []);
      setConstructionDetails(data.data.marketPublicConstructionDetail || []); //  const testdocID = "67cc7b9f5ce5a960d78030a3";
      //  const docData = await getDocument(testdocID ,token)
      //  //.log('docccc' , docData);

      setApplication(data.data);
      setButtonData(data.data.buttonName);

      setRole(data.data?.role);
      setDocs(data.data?.docs);

      setTransaction(data?.data?.panelEnginnerAppTransaction);
      const application = data?.data;

      const rejectedDocs = application?.rejectedDocName;
      const rejectedFields = application?.rejectedFieldName;
      //.log("resubrejjjj fields docs", rejectedFields, rejectedDocs);
      setRejectedDocName(rejectedDocs);
      setRejectedFields(rejectedFields);
      //.log("rejecteddd docss and fields", rejectedDocs, rejectedFields);

      //  const app = data.data;
      //  const curradd = app.currAddress;
      //  //.log('ccc',curradd)
      //  setAddressData(curradd)
    } catch (err) {
      setError("Failed to load application details");
    } finally {
      setLoading(false);
      //.log("apppp", application);
    }
  };

  // let itArray;

  let testArray = () => {
    const today = new Date();
    const currentYear = today.getFullYear();
    const augustFirst = new Date(currentYear, 7, 1); // August = month 7 (0-based)

    // If today is before August 1, current FY is not included
    const endYear = today < augustFirst ? currentYear - 1 : currentYear;

    const fiscalYears = [];

    for (let i = 2; i >= 0; i--) {
      const start = endYear - i;
      const end = start - 1;
      fiscalYears.push(`FY ${end}-${start}`);
    }
    setItArray(fiscalYears);
    return fiscalYears;
  };

  useEffect(() => {
    testArray();
  }, []);
  

  const fetchAllDistrict = async (token: string): Promise<Option[]> => {
    try {
      const response = await getAllDistricts(token);
      //.log('resss', response)
      // response.data:[]
      const district: any[] = response.data;
      //.log(' district Data', district)

      const options: Option[] = district.map((dist) => ({
        value: dist?.Department_Idetifier,
        label: dist?.District,
      }));

      //.log('Options:', options);
      return options;
    } catch (error) {
      //.error('Error fetching APMC data:', error);
      return [];
    }
  };

  const handleEdit = (application?: any) => {
    if (!application) return;
    fetchAllDistrict(token).then((options) => setDistrictOptions(options));
  };

  const afterBorderDistrictUpdate = () => {
    fetchApplicationDetails(applicationId);
  };

  useEffect(() => {
    //.log("pppppppppp");

    //.log("param id", applicationId);
    fetchAllDistrict(token).then((options) => setDistrictOptions(options));

    fetchApplicationDetails(applicationId);
    // fetchTraderApplicationButton();
  }, []);
  // let itArray = ["2021-2022","2022-2023","2023-2024"];

  return (
    <>
      <div>
        <div className="cardhead page-wrapper">
          <div className="container-fluid content">
            <div className="page-header">
              <div className="row">
                <div className="col">
                  <h3 className="page-title">
                    {language.panel_engineer_preview}
                  </h3>
                  {/* <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>Dashboard</Link>
                    </li>
                    <li className="active breadcrumb-item">Horizontal Form</li>
                  </ul> */}
                </div>
              </div>
            </div>
          
            {application?.appStatusLevel == "hoSuperintendentAfterApproveAction" &&
              roleIdentifier == "HOS" && (
                <div>
                  <div className="">
                    <h3 className="text-danger fs-14 page-title">
                      {language.dlusl}
                    </h3>
                    <PanelApproveUnsigned
                      application={application}
                      partners={partners}
                      officeAddress={officeAddress}
                      applicationId={applicationId}
                      buttonData={buttonData}
                      setLicense={setLicense}
                    />
                  </div>
                </div>
              )}

            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header d-flex justify-content-between">
                    <h5 className="card-title">{language.app_details} ({application?.applicationId})</h5>
                    {( roleIdentifier=="DT" || roleIdentifier=="DY" || roleIdentifier=="HOS") && <h4>Outward Number: {application?.trackingNo} </h4>}
                  </div>
                  <div>
                    {[ "HOS", "DY", "DT"].includes(roleIdentifier) && application?.hasDrCheckedApplication=="true" && <h4 className="p-4 text-success">જીલ્લા રજીસ્ટ્રારશ્રીનું પ્રમાણપત્ર :
ઉપર મુજબની તમામ વિગતોની અસલ પ્રમાણપત્રો સાથે અમોએ ચકાસણી કરેલ છે. જે
આ અંગેના વડી કચેરીના પરીપત્રો સાથે સુસંગત છે. તેનું પ્રમાણપત્ર આપું છું. પેનલ ઈજનેર
તરીકે નિમણૂક આપવા ભલામણ છે. ( We have verified all the above details with the original certificates. Which is in line with the circulars of the head office in this regard. I certify it. It is recommended to appoint a panel engineer.)</h4>}
                  </div>
                  <div className="card-body">
                    {loading ? (
                      <p>Loading application details...</p>
                    ) : error ? (
                      <p className="text-danger">{error}</p>
                    ) : (
                      <div className="table-responsive">
                        {/* First Table */}
                        <table className="table table-nowrap mb-0">
                          <thead>
                            <tr>
                              <th>{language.applicant_name}</th>

                              <th>{language.partnership_firm}</th>
                              <th>{language.district}</th>
                              <th className="d-flex gap-2">
                                {application?.departmentSelectType === "entireState"
                                  ? "Entire State"
                                  : language.borderDistrict}
                                {roleIdentifier == "DT" && (
                                  <Link
                                    to="#"
                                    data-bs-toggle="modal"
                                    data-inert={true}
                                    data-bs-target="#editBorder"

                                    // onClick={() => handleEdit(application)}
                                  >
                                    <i
                                      className=" ti ti-edit"
                                      style={{ cursor: "pointer" }}
                                    />
                                  </Link>
                                )}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {application ? (
                              <tr>
                                <td>{application.applicantName}</td>

                                <td>
                                  {application?.isPartner == "true"
                                    ? "Yes"
                                    : "No"}
                                </td>
                                <td>{application?.department.District}</td>
                                <td style={{ whiteSpace: "normal" }}>
                                  {application?.departmentSelectType === "entireState"
                                    ? "Entire State(Gujarat)"
                                    : application?.borderDepartmentIdentifier
                                        ?.length
                                    ? application.borderDepartmentIdentifier
                                        .map((data) => data.District)
                                        .join(", ")
                                    : "N/A"}
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td colSpan={4} className="text-center">
                                  No application details available.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>

                        {/* Second Table */}
                      </div>
                    )}
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-xl-12">
                  <div className="card">
                    <div>
                      <h5 className="mb-2 px-4 py-2">
                        {language.partner_details}:
                      </h5>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>Sr No.</th>
                                <th>{language.name}</th>
                                <th>{language.age_in_year}</th>
                                <th>{language.address}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={4}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : partners.length > 0 ? (
                                partners.map((partner, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}.</td>
                                    <td>{partner?.name || "N/A"}</td>
                                    <td>{partner?.partnerAge || "N/A"}</td>
                                    <td>{partner?.address || "N/A"}</td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={4} className="text-center">
                                    No Partners available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                    <div className="card-body">
                      <div>
                        <h5 className="mb-2">Full Address:</h5>
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-nowrap mb-0">
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      padding: "10px",
                                      textAlign: "left",
                                    }}
                                  >
                                    {language.address}
                                  </th>
                                  <th>{language.post}</th>
                                  <th>{language.taluka}</th>
                                  <th>{language.district}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td colSpan={4} className="text-center">
                                      Loading...
                                    </td>
                                  </tr>
                                ) : error ? (
                                  <tr>
                                    <td
                                      colSpan={4}
                                      className="text-center text-danger"
                                    >
                                      {error}
                                    </td>
                                  </tr>
                                ) : addressData ? (
                                  <tr>
                                    <td>{addressData.address}</td>
                                    <td>{addressData.post}</td>
                                    <td>{addressData.taluka}</td>
                                    <td>{addressData.district}</td>
                                  </tr>
                                ) : (
                                  <tr>
                                    <td colSpan={4} className="text-center">
                                      No address details available.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div className="mb-3">
                        <h5 className="mb-2">
                          {language.registered_office_address}:
                        </h5>

                        {/* Office Address Table */}
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-nowrap mb-0">
                              <thead>
                                <tr>
                                  <th
                                    style={{
                                      padding: "10px",
                                      textAlign: "left",
                                    }}
                                  >
                                    {language.address}
                                  </th>
                                  <th>{language.post}</th>
                                  <th>{language.taluka}</th>
                                  <th>{language.district}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td colSpan={4} className="text-center">
                                      Loading...
                                    </td>
                                  </tr>
                                ) : error ? (
                                  <tr>
                                    <td
                                      colSpan={4}
                                      className="text-center text-danger"
                                    >
                                      {error}
                                    </td>
                                  </tr>
                                ) : officeAddress ? (
                                  <tr>
                                    <td>{officeAddress.address}</td>
                                    <td>{officeAddress.post}</td>
                                    <td>{officeAddress.taluka}</td>
                                    <td>{officeAddress.district}</td>
                                  </tr>
                                ) : (
                                  <tr>
                                    <td colSpan={4} className="text-center">
                                      No office address details available.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>

                        {/* Office Details Table */}
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-nowrap mb-0">
                              <thead>
                                <tr>
                                  <th>{language.registered_email_id}</th>
                                  <th>{language.mobile}</th>
                                  <th>{language.DOB}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td colSpan={4} className="text-center">
                                      Loading...
                                    </td>
                                  </tr>
                                ) : error ? (
                                  <tr>
                                    <td
                                      colSpan={4}
                                      className="text-center text-danger"
                                    >
                                      {error}
                                    </td>
                                  </tr>
                                ) : officeDetails ? (
                                  <tr>
                                    <td>{officeDetails.registeredEmail}</td>
                                    <td>{officeDetails.mobileNo}</td>
                                    <td>{officeDetails.DOB}</td>
                                  </tr>
                                ) : (
                                  <tr>
                                    <td colSpan={4} className="text-center">
                                      No office details available.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <h5 className="mb-2">{language.education_details}:</h5>
                      <div className="card-body">
                        <div className="table-responsive">
                          <table className="table table-nowrap mb-0">
                            <thead>
                              <tr>
                                <th>Sr No.</th>
                                <th>{language.education}</th>
                                <th>{language.specialization}</th>
                                <th>{language.attachement}</th>
                              </tr>
                            </thead>
                            <tbody>
                              {loading ? (
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    Loading...
                                  </td>
                                </tr>
                              ) : error ? (
                                <tr>
                                  <td
                                    colSpan={3}
                                    className="text-center text-danger"
                                  >
                                    {error}
                                  </td>
                                </tr>
                              ) : education.length > 0 ? (
                                education.map((edu, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}.</td>
                                    <td>{educationLevelMap[edu.standard] || edu.standard}</td>

<td>
  {edu.specialization
    ? professionMap[edu.specialization] || edu.specialization
    : "N/A"}
</td>
                                    <td>
                                      {edu.fileName ? (
                                        <Link
                                          to="#"
                                          data-bs-toggle="modal"
                                          data-inert={true}
                                          data-bs-target="#single_modal"
                                          className="btn btn-primary align-items-center"
                                          onClick={() =>
                                            setSelectedDocId(edu?.docId)
                                          }
                                        >
                                          {language.preview}
                                        </Link>
                                      ) : (
                                        "No Attachment"
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan={3} className="text-center">
                                    No education records available.
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                      {
                        application && application?.structuralDetail && Object.keys(application?.structuralDetail).length >0 && 
                        <>
                      <h5 className="mb-2">{language.structuralDetail}:</h5>
                       <Link
                            to="#"
                            data-bs-toggle="modal"
                            data-inert={true}
                            data-bs-target="#single_modal"
                            className=" btn btn-primary align-items-center mb-4"
                            onClick={() =>
                              setSelectedDocId(
                               application?.structuralDetail.docId
                              )
                            }
                          >
                            {language.preview}
                          </Link>
                        
                        </>
                        
                      }
                         {
                                              application && application?.docs.find(item=>item?.documentName==="otherDoc")  && 
                                              <>
                                            <h5 className="mb-2">{language.otherDoc}:</h5>
                                              <Link
                                                  to="#"
                                                  data-bs-toggle="modal"
                                                  data-inert={true}
                                                  data-bs-target="#single_modal"
                                                  className=" btn btn-primary align-items-center mb-4"
                                                  onClick={() =>
                                                    setSelectedDocId(
                                                     application?.docs.find(item=>item?.documentName==="otherDoc")?.docId
                                                    )
                                                  }
                                                >
                                                  {language.preview}
                                                </Link>
                                              
                                              </>
                                              
                                            }
                      <div>
                        <h5 className="mb-2">{language.experience_details}:</h5>
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-nowrap mb-0">
                              <thead>
                                <tr>
                                  <th>Sr No.</th>
                                  <th>{language.project_name}</th>
                                  <th>{language.project_awarded_by}</th>
                                  <th>{language.attachements}</th>
                                  <th>{language.start_date}</th>
                                  <th>{language.end_date}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      Loading...
                                    </td>
                                  </tr>
                                ) : error ? (
                                  <tr>
                                    <td
                                      colSpan={5}
                                      className="text-center text-danger"
                                    >
                                      {error}
                                    </td>
                                  </tr>
                                ) : experience.length > 0 ? (
                                  experience.map((exp, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}.</td>
                                      <td>{exp.projectName}</td>
                                      <td>
                                        {exp.projectAwardedby
                                          ? exp.projectAwardedby
                                          : "N/A"}
                                      </td>
                                      <td>
                                        {exp?.eveidenceProof?.fileName ? (
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-inert={true}
                                            data-bs-target="#single_modal"
                                            className=" btn btn-primary align-items-center "
                                            onClick={() =>
                                              setSelectedDocId(
                                                exp?.eveidenceProof?.docId
                                              )
                                            }
                                          >
                                            {language.preview}
                                          </Link>
                                        ) : (
                                          "No Attachment"
                                        )}
                                      </td>
                                      <td>{exp.startDate}</td>
                                      <td>{exp.endDate}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      No experience records available.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-12 m-2">
                        <h5>{language.business_engineer}</h5>
                        <p>
                          <strong>
                            {application?.yrOfExpAsBusErr ?? "Not provided"}
                          </strong>
                        </p>
                      </div>
                      <div>
                        <h5 className="mb-2">{language.work_performed}:</h5>
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-nowrap mb-0">
                              <thead>
                                <tr>
                                  <th>Sr No.</th>
                                  <th>{language.project_name}</th>
                                  <th>{language.project_awarded_by}</th>
                                  <th>{language.attachements}</th>
                                  <th>{language.start_date}</th>
                                  <th>{language.end_date}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      Loading...
                                    </td>
                                  </tr>
                                ) : error ? (
                                  <tr>
                                    <td
                                      colSpan={5}
                                      className="text-center text-danger"
                                    >
                                      {error}
                                    </td>
                                  </tr>
                                ) : workPerformed.length > 0 ? (
                                  workPerformed.map((work, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}.</td>
                                      <td>{work.projectName}</td>
                                      <td>
                                        {work.projectAwardedby
                                          ? work.projectAwardedby
                                          : "N/A"}
                                      </td>

                                      <td>
                                        {work?.eveidenceProof?.fileName ? (
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-inert={true}
                                            data-bs-target="#single_modal"
                                            className=" btn btn-primary align-items-center "
                                            onClick={() =>
                                              setSelectedDocId(
                                                work.eveidenceProof.docId
                                              )
                                            }
                                          >
                                            {language.preview}
                                          </Link>
                                        ) : (
                                          "No Attachment"
                                        )}
                                      </td>
                                      <td>{work.startDate}</td>
                                      <td>{work.endDate}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      No work performed records available.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                      <div>
                        <h5 className="mb-2">{language.done_construction}:</h5>
                        <div className="card-body">
                          <div className="table-responsive">
                            <table className="table table-nowrap mb-0">
                              <thead>
                                <tr>
                                  <th>Sr No.</th>
                                  <th>{language.project_name}</th>
                                  <th>{language.project_awarded_by}</th>
                                  <th>{language.attachements}</th>
                                  <th>{language.start_date}</th>
                                  <th>{language.end_date}</th>
                                </tr>
                              </thead>
                              <tbody>
                                {loading ? (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      Loading...
                                    </td>
                                  </tr>
                                ) : error ? (
                                  <tr>
                                    <td
                                      colSpan={5}
                                      className="text-center text-danger"
                                    >
                                      {error}
                                    </td>
                                  </tr>
                                ) : constructionDetails.length > 0 ? (
                                  constructionDetails.map((detail, index) => (
                                    <tr key={index}>
                                      <td>{index + 1}.</td>
                                      <td>{detail.projectName}</td>
                                      <td>
                                        {detail.projectAwardedby
                                          ? detail.projectAwardedby
                                          : "N/A"}
                                      </td>
                                      <td>
                                        {detail?.eveidenceProof?.fileName ? (
                                          <Link
                                            to="#"
                                            data-bs-toggle="modal"
                                            data-inert={true}
                                            data-bs-target="#single_modal"
                                            className=" btn btn-primary align-items-center"
                                            onClick={() =>
                                              setSelectedDocId(
                                                detail?.eveidenceProof?.docId
                                              )
                                            }
                                          >
                                            {language.preview}
                                          </Link>
                                        ) : (
                                          "No Attachment"
                                        )}
                                      </td>
                                      <td>{detail.startDate}</td>
                                      <td>{detail.endDate}</td>
                                    </tr>
                                  ))
                                ) : (
                                  <tr>
                                    <td colSpan={5} className="text-center">
                                      No construction records available.
                                    </td>
                                  </tr>
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div className="row d-flex align-items-center">
                        <div className="col-md-6">
                          <h5 className="mb-2">{language.it_returns}</h5>
                          <div className="card-body">
                            <div className="table-responsive">
                              {itArray && application?.itReturnDetail?.length > 0  ? (
                                application?.itReturnDetail?.map(
                                  (item, index) => (
                                    <div key={index} className="mb-2">
                                      <Link
                                        to="#"
                                        data-bs-toggle="modal"
                                        data-inert={true}
                                        data-bs-target="#single_modal"
                                        className="btn btn-primary align-items-center"
                                        onClick={() =>
                                          setSelectedDocId(item?.docId)
                                        }
                                      >
                                        {language.preview} -{" "}
                                        {"IT Returns Document-" +
                                          item.documentName.split("_")[1] }
                                      </Link>
                                      <span className="ms-2">
                                        {item?.fileName}
                                      </span>
                                    </div>
                                  )
                                )
                              ) : (
                                <div>No Attachment</div>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* {["HJC", "HOS", "DY", "DT"].includes(
                          roleIdentifier
                        ) && (
                          <div className="col-md-6">
                            <div className="d-flex flex-column align-items-start">
                              <h2>
                                <label className="form-label fs-19 fw-bold mb-2">
                                  DR Declaration To Certify The Verification
                                </label>
                              </h2>
                              {application?.regClarificationToHoDetail
                                ?.fileName ? (
                                <Link
                                  to="#"
                                  data-bs-toggle="modal"
                                  data-inert={true}
                                  data-bs-target="#single_modal"
                                  className="btn btn-primary align-items-center"
                                  onClick={() =>
                                    setSelectedDocId(
                                      application?.regClarificationToHoDetail
                                        ?.docId
                                    )
                                  }
                                >
                                  {language.preview} - Declaration
                                </Link>
                              ) : (
                                <p>No Attachment</p>
                              )}
                            </div>
                          </div>
                        )} */}
                      </div>

                      {/* {roleIdentifier === "Dr" &&  (
                        <div className="col-md-6 mb-3 ">
                          <label className="form-label d-flex  ">
                            <h5> Declaration to certify the verification</h5>
                            <span className="text-danger">*</span>
                          </label>
                          <div className="">
                            <GujaratiLetterDownload
                              name={application?.applicantName}
                              district={application?.department?.District}
                            />
                          </div>
                          <div className="d-flex align-items-center">
                            <input
                              type="file"
                              className="form-control"
                              accept=".pdf, .jpeg, .jpg"
                              onChange={handleFileUpload}
                            />

                            {`Uploaded file :${
                              application &&
                              application?.regClarificationToHoDetail?.fileName
                                ? application?.regClarificationToHoDetail
                                    ?.fileName
                                : ""
                            }`}
                            {decerror && (
                              <div className="text-danger mb-2">{decerror}</div>
                            )}
                          </div>
                        </div>
                      )} */}
                    

                      {transaction && transaction.length > 0 && (
                        <Link
                          to="#"
                          data-bs-toggle="modal"
                          data-inert={true}
                          data-bs-target="#comment_modal"
                          className="d-flex btn btn-primary align-items-center w-25 mb-4"
                        >
                          <i className="me-2 ti ti-file-description" />
                          {language.view_comment}
                        </Link>
                      )}

                <>
                  {(
                    (application?.appStatusLevel === "dclerkAfterRejectionAction" && roleIdentifier === "JC") ||
                    (application?.appStatusLevel === "hoSuperintendentAfterRejectionAction" && roleIdentifier === "HOS")
                  ) && (
                    <div>
                      <div className="mb-0">
                        <h3 className="text-danger fs-15 page-title">
                          {language.rej_da}
                        </h3>
                        {errorr.requery && (
                        <p style={{ color: "red" }}>{errorr.requery}</p>
                       )}
                        <MultiSelectCheckbox
                          Options={fieldsOptions}
                          onChange={handleSelectionChange}
                          docs={docs}
                        />
                        
                        {rejectedFields && rejectedFields.length > 0 && rejectedFields.map((fieldKey) => (
                          <div key={fieldKey} className="mb-3">
                            <label className="form-label">{language[fieldKey]} Comment (min 5 words)</label>
                            <input
                              type="text"
                              className={`form-control ${commentErrors[fieldKey] ? "is-invalid" : ""}`}
                              value={fieldComments[fieldKey] || ""}
                              onChange={(e) => handleCommentChange(fieldKey, e.target.value)}
                              placeholder={`Enter comment for ${language[fieldKey]}`}
                            />

                               {commentErrors[fieldKey] && (
                                <div className="invalid-feedback">
                                  {commentErrors[fieldKey]}
                                </div>
                              )}
                          </div>
                        ))}
                      </div>
                      {errorr.comment && (
                        <p style={{ color: "red" }}>{errorr.comment}</p>
                      )}
                      
                    </div>
                    
                  )}
                </>

                      

                    { ["JC" , "COM" , "Dr"].includes(roleIdentifier) && (application?.status === "pending" || application?.status === "resubmission") && <div className="mt-2">
                      <div className="form-check">
                        <input
                          type="checkbox"
                          id="declaration"
                          className="form-check-input"
                          checked={isChecked}
                          onChange={() => setIsChecked(!isChecked)}
                        />
                        <label htmlFor="declaration" className="form-check-label fw-bold">
                          {roleIdentifier=="Dr" ? drText : jcCoText }
                        </label>
                      </div>
                   
                        {errorr.isChecked && <p style={{ color: "red" }}>{errorr.isChecked}</p>}
                    </div>}

                    </div>
                  

                    <div className="d-flex justify-content-between p-4 w-50">
                      {buttonData &&
                        buttonData.length > 0 &&
                        buttonData[0].appStatusLevel != "licenseGranted" &&
                        role !== "" && 
                        roleIdentifier === role && (
                          <div className="row">
                           { 
                           !((["JC"].includes(role) && application.appStatusLevel=="dclerkAfterRejectionAction") || (["HOS"].includes(role) && application.appStatusLevel=="hoSuperintendentAfterRejectionAction")) && 
                           <div>
                            <textarea
                              className="form-control mb-2"
                              placeholder="Enter your comment (min 5 words)"
                              name="currAt"
                              value={comment}
                              onChange={(e) => setComment(e.target.value)}
                              rows={4}
                              // maxLength={100}
                            />

                            {/* {errorr && (
                              <div className="text-danger mb-2">{errorr}</div>
                            )} */}

                            {errorr.comment && <p style={{ color: "red" }}>{errorr.comment}</p>}

                            </div>
                            }
                    

                            <div className="d-flex gap-2">
                              {buttonData.map((button) => (
                                <button
                                  key={button.status}
                                  className={`btn ${
                                    button.status === "reject"
                                      ? "btn-danger"
                                      :  button.status === "permanentReject" ? "btn-secondary" : "btn-success"
                                  } h-10 w-70`}
                                  onClick={() =>
                                    handleSubmit(
                                      button.status,
                                      button.appStatusLevel
                                    )
                                  }
                                  disabled={isDisabled}
                                >
                                  {button.buttonLabel}
                                  {/* {isDisabled ? "Processing..." : button.buttonLabel} */}
                                </button>
                              ))}
                            </div>
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            
          </div>
        </div>
        {applicationId ? (
          <>
            <PdfLoaderModal
              applicationId={applicationId}
              applicationType="panel"
            />
            <SingleView docId={selectedDocId} />
          </>
        ) : (
          <p className="text-danger">Application ID is missing.</p>
        )}
      </div>
      <ApplicationTimelineModal comments={transaction} />
      <EditPanelBorderDistrictModal
        selectedDistrict={application?.department?.District}
        districtOptions={districtOptions}
        token={token}
        applicationId={applicationId}
        onUpdate={afterBorderDistrictUpdate}
      />
      <ToastContainer autoClose={3000} position="top-right"/>
    </>
  );
};

export default PreviewPanelApplication;
